import {Component, OnInit} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomValidators } from '../../../custom-validators';
import { DashboardService } from '../../services/dashboard.service';
import { SupportRequestArgs } from '../../interfaces/support-request-args';
import { MessageService } from 'primeng/api';
import {PersistanceService} from '../../../services/persistance.service';

export interface SupportDropdown {
  value: any;
  label: string;
}

@Component({
  selector: 'app-support-request',
  templateUrl: './support-request.component.html',
  styleUrls: ['./support-request.component.less']
})
export class SupportRequestComponent implements OnInit{
  supportTypes: SupportDropdown[] = [
    {value: 'support', label: 'Сообщить о технической проблеме'},
    {value: 'manager_question', label: 'Задать вопрос менеджеру'},
    {value: 'improvement', label: 'Предложить улучшение'},
  ];


	form = new UntypedFormGroup({
		name: new UntypedFormControl('', [CustomValidators.required, Validators.maxLength(45)]),
		phone: new UntypedFormControl('', [CustomValidators.required, Validators.maxLength(45)]),
		email: new UntypedFormControl('', [CustomValidators.required, Validators.email, Validators.maxLength(45)]),
		message: new UntypedFormControl('', [CustomValidators.required]),
    type: new UntypedFormControl(null, [CustomValidators.required]),
	});

	formPending = false;

  constructor(private ref: DynamicDialogRef,
							private dashboardService: DashboardService,
              private persistanceService: PersistanceService,
							private messageService: MessageService) { }

  ngOnInit(): void {
    this.getValuesFromLocalStorageAndPatchToForm();
  }

	submitForm(): void {
		this.form.markAllAsTouched();

		if (this.form.invalid || this.formPending) {
			return;
		}
		this.formPending = true;

		const args: SupportRequestArgs = {
			name: this.form.get('name')?.value,
			phone: this.form.get('phone')?.value,
			email: this.form.get('email')?.value,
			message: this.form.get('message')?.value,
			type: this.form.get('type')?.value,
		};
    this.setSupportRequestArgsToLocalStorage(args);

		// Server request
		this.dashboardService.supportRequest(args)
			.subscribe(response => {
				this.formPending = false;

				if (response.success) {
					// Showing success result message
					this.messageService.add({
						severity: 'success',
						summary: 'Обращение к Оператору',
						detail: 'Спасибо за обращение! Оператор ответит Вам в течение 2-х рабочих дней.',
						life: 10 * 1000,
					});

					// Closing dialog
					this.closeDialog();
				} else {
					// Error message
					this.messageService.add({
						severity: 'error',
						summary: 'Серверная ошибка',
						detail: 'Не удалось отправить сообщение. Пожалуйста, повторите попытку позже.',
						life: 10 * 1000,
					});
				}
			});

	}

	closeDialog(): void {
		this.ref.close();
	}

  getValuesFromLocalStorageAndPatchToForm(): void {
    this.form.patchValue({
      phone: this.persistanceService.get('userPhone'),
      name: this.persistanceService.get('userFirstName'),
      email: this.persistanceService.get('userEmail'),
    });
  }

  setSupportRequestArgsToLocalStorage(args: SupportRequestArgs): void {
    this.persistanceService.set('userPhone', args.phone);
    this.persistanceService.set('userFirstName', args.name);
    this.persistanceService.set('userEmail', args.email ? args.email : '');
  }

}
